import { render } from "./controlpanel.vue?vue&type=template&id=83c9a0d8&scoped=true&ts=true"
import script from "./controlpanel.vue?vue&type=script&lang=ts"
export * from "./controlpanel.vue?vue&type=script&lang=ts"

import "./controlpanel.vue?vue&type=style&index=0&id=83c9a0d8&lang=scss&scoped=true"

import exportComponent from "D:\\ct-construction-ts-mobile\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83c9a0d8"]])

export default __exports__